import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Button } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { useForm } from 'react-hook-form';
import { history, useLocation } from 'umi';
import { useDispatch, useSelector } from 'dva';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import BasicML from '../components/BasicML';
import DetailML from './components/DetailML';
import Loading from '@/components/LoadingML/LoadingML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import TitleML from './components/TitleML';
import { SelectFieldCom } from '../components/FormType';
import webStorage from '@/utils/storageManager';
import LabelRules from './components/label_rules';
import CollectionLabelStyled from './StatisticsLabelStyles';

const createId = () => {
  return Math.random().toString(36).substr(2, 10);
};

const createObj = () => {
  return {
    id: createId(),
    operation: null, // 标签规则运算符, > < =
    operationValue: null, // 标签运算需要的数值 > < = 对应的值
    operationAnd: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等
    operationAndValue: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等对应的值
    operationType: null, // 标签运算类型 1-绝对的 2-相对的 3-有值 4-无值
    outsideSort: null, //用于排序
    profileTagCollectionId: null, //集合标签单中个标签物理ID
    profileTagId: null, // 标签物理ID
    type: null, //标签规则类型 1-包含 2-排除
    valueFieldIds: null, // 标签规则所选字段ID
    valueType: null, // 类型 1-文本输入 2-下拉框 3-日期类型 4-日期时间类型
    withinSort: null, // 标签规则'且'集合的排序
  };
};
// 每条新增原始数据
const createDataObj = () => {
  return {
    id: createId(),
    operation: null, // 标签规则运算符, > < =
    operationAnd: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等
    operationAndValue: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等对应的值
    operationType: null, // 标签运算类型 1-有值 2-无值 3-绝对 4-相对
    operationValue: null, // 标签运算需要的数值 > < = 对应的值
    profileTagId: null, // 标签物理ID
    valueFieldIds: null, // 标签规则所选字段ID
    valueType: null, // 类型 1-文本输入 2-下拉框 3-日期类型 4-日期时间类型
    sqlText: null,
    url: null,
  };
};
//初始化详细设定数据结构
const initDetailForm = () => {
  return {
    id: createId(),
    tagCollectionRuleIn: [],
    tagCollectionRuleOut: [],
  };
};

const initValueFieldIds = (ids, list) => {
  let data = [];
  const init = (pIds, pList) => {
    if (pIds.length > 0) {
      for (let i = 0; i < pIds.length; i++) {
        const d = pList.find((item) => item.id === pIds[i]);
        if (d) {
          data.push(d);
          const fIds = pIds.filter((it) => it !== pIds[i]);
          fIds.length > 0 && init(fIds, d.children);
          break;
        }
      }
    }
  };
  init(ids, list);
  return data;
};

export default () => {
  // 用户菜单权限
  const userAuths = webStorage.get('USER')?.authorities;
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const queryType = query?.opt;
  const tagId = query.tagId ? Number(query.tagId) : null;
  const [tagCollectionInfo, setTagCollectionInfo] = useState(null);
  const [deleteIds, setDeleteIds] = useState([]); //删除的id
  const [submitStatus, setSubmitStatus] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [saveOpen, setSaveOpen] = useState({
    tips: '',
    status: false,
    title: '',
  });
  const submitRef = useRef();
  const { ruleLabelDirectoryList } = useSelector(
    (state) => state.statisticsCreateLabel,
  );
  const {
    handleSubmit,
    control,
    errors,
    getValues,
    setValue,
    setError,
    clearErrors,
    watch,
  } = useForm();
  const watchValueFieldId = watch('valueFieldId');
  //取值方式
  const [beHavCondition, setBeHavCondition] = useState([]);
  // const [type, setType] = useState();
  // 字典项
  const {
    PROFILE_COLLECT_OPERATOR,
    PROFILE_DATE_OPERATOR, //日期类
    PROFILE_NUMERICAL_OPERATOR, //数值类
    // TAG_RULE_BEHAVIOR, //行为
    PROFILE_TEXT_OPERATOR, //文本
    PROFILE_ABSOLUTE_DATE_OPERATOR, //绝对日期类
    PROFILE_RELATIVE_DATE_OPERATOR, //相对日期类
    PROFILE_RELATIVE_DATE_RANGE_OPERATOR, //相对日期范围操作
    PROFILE_FILE_VALUE_METHOD_NUMERICAL, //取值方式 数值
    PROFILE_FILE_VALUE_METHOD_TEXT, //文本
    PROFILE_FILE_VALUE_METHOD_DATE, //日期
  } = webStorage.get('DICTOBJ') || [];
  const dicObj = {
    PROFILE_COLLECT_OPERATOR,
    PROFILE_TEXT_OPERATOR,
    PROFILE_NUMERICAL_OPERATOR,
    PROFILE_DATE_OPERATOR,
    PROFILE_ABSOLUTE_DATE_OPERATOR,
    PROFILE_RELATIVE_DATE_OPERATOR,
    PROFILE_RELATIVE_DATE_RANGE_OPERATOR,
    PROFILE_FILE_VALUE_METHOD_NUMERICAL,
    PROFILE_FILE_VALUE_METHOD_TEXT,
    PROFILE_FILE_VALUE_METHOD_DATE,
  };

  const [tagRule, setTagRule] = useState([createDataObj()]);
  const watchTestParams = watch(`valueFieldIds-${tagRule[0]?.id}`);
  const loadingEffect = useSelector((state) => state.loading);
  const loading =
    loadingEffect.effects['statisticsCreateLabel/queryTagBehaviorList'] ||
    loadingEffect.effects['labelManage/getQueryTagTreeCL'] ||
    loadingEffect.effects['statisticsCreateLabel/queryFileList'] ||
    loadingEffect.effects['statisticsCreateLabel/getQueryTagOperatorValue'] ||
    loadingEffect.effects['statisticsCreateLabel/queryTagAndRule'];
  const handleClickOpen = () => {
    if (queryType === 'detail') {
      history.goBack();
      return;
    }
    setSaveOpen({
      status: true,
      tips: '退出后将不保存设置内容，确定要退出吗？',
      title: '退出',
    });
  };

  const onSubmitError = () => {
    setSubmitStatus(true);
    window.message.toast({
      type: 'error',
      message: '输入有误',
    });
  };

  const onSubmitSuccess = (data) => {
    if (!submitStatus) {
      return;
    }
    setIsLoading(true);
    setSubmitStatus(false);
    const postData = {};
    postData.id = tagId ? tagId : null;
    postData.name = data.name;
    postData.nameEn = '';
    postData.pid = data.pid;
    postData.remark = data.remark;

    postData.ruleType = watchTestParamsData.find(
      (item) => item.id === data.valueFieldId,
    ).type;
    postData.source = 1;
    postData.type = 234;
    postData.status = data.status;
    postData.updateStrategy = Number(data.updateStrategy);
    const newTagCollectionInfo = JSON.parse(JSON.stringify(tagCollectionInfo));
    const newTagRule = JSON.parse(JSON.stringify(tagRule));
    const ruleBehaviorData = {};
    ruleBehaviorData.id =
      !tagId || typeof newTagRule[0].id !== 'number' ? null : newTagRule[0].id;
    ruleBehaviorData.operation = newTagRule[0].operation || null;
    ruleBehaviorData.operationAnd = newTagRule[0].operationAnd || null;
    ruleBehaviorData.operationAndValue =
      newTagRule[0].operationAndValue || null;
    ruleBehaviorData.operationType = newTagRule[0].operationType || null;
    ruleBehaviorData.operationValue = newTagRule[0].operationValue
      ? typeof newTagRule[0].operationValue === 'object'
        ? JSON.stringify(newTagRule[0].operationValue)
        : newTagRule[0].operationValue
      : null;
    ruleBehaviorData.profileTagId = newTagRule[0].profileTagId || null;
    ruleBehaviorData.valueFieldId = data.valueFieldId || null;
    ruleBehaviorData.valueFieldIds = newTagRule[0].valueFieldIds.map(
      (item) => item.id,
    );
    ruleBehaviorData.valueMethod = data.valueMethod || null;
    ruleBehaviorData.valueType = newTagRule[0].valueType || null;
    newTagCollectionInfo.forEach((item) => {
      let tagCollectionRule = [];
      if (item.tagCollectionRuleIn) {
        item.tagCollectionRuleIn.forEach((it) => {
          delete it.id;
          it.withinItem.forEach((i) => {
            if (!tagId || typeof i.id !== 'number') {
              i.id = null;
            }
            i.operationAnd = i.operationAnd ? i.operationAnd : null;
            i.valueFieldIds = i.valueFieldIds.map((x) => x.id);
          });
        });
        const inData = {
          type: 1,
          tagRuleOutsideData: item.tagCollectionRuleIn,
        };
        tagCollectionRule.push(inData);
      }
      if (!tagId || typeof item.id !== 'number') {
        item.id = null;
      }
      delete item.tagCollectionRuleOut;
      delete item.tagCollectionRuleIn;

      item.tagCollectionRule = tagCollectionRule;
    });
    postData.tagRule =
      newTagCollectionInfo[0]?.tagCollectionRule?.[0]?.tagRuleOutsideData
        ?.length > 0
        ? newTagCollectionInfo[0]?.tagCollectionRule
        : [];
    // postData.deleteTagCollectionIds = deleteIds;
    postData.ruleBehaviorData = ruleBehaviorData;
    window.NE_DAWN.trigger(submitRef.current, {
      event: '_ec', // 事件名
      params: { ...postData }, // 事件公参
    });
    dispatch({
      type: 'statisticsCreateLabel/insertOrUpdateTagAndRule',
      payload: {
        values: postData,
      },
      callback: (code) => {
        if (code === 0) {
          window.message.toast({
            type: 'success',
            message: !tagId ? '保存标签成功' : '修改标签成功',
            title: '成功',
          });
          history.goBack();
        }
        setIsLoading(false);
        setSubmitStatus(true);
      },
    });
  };

  useEffect(() => {
    //默认不出现一条条件范围
    !tagId && setTagCollectionInfo([initDetailForm()]);
    !tagId && setValue('updateStrategy', '1');
    !tagId && setValue('status', '2');
  }, [setValue, tagId]);
  useEffect(() => {
    dispatch({
      type: 'labelManage/getQueryTagTreeCL',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    const fetch = async () => {
      let directoryList = null;
      await dispatch({
        type: 'statisticsCreateLabel/queryTagBehaviorList',
        payload: {
          values: {
            type: 234,
          },
        },
      });
      await dispatch({
        type: 'statisticsCreateLabel/queryFileList',
        payload: {
          values: {},
        },
        callback: (list) => {
          directoryList = list;
        },
      });
      await dispatch({
        type: 'statisticsCreateLabel/queryFileList',
        payload: {
          values: {
            type: 4,
          },
        },
        callback: () => {},
      });
      await dispatch({
        type: 'statisticsCreateLabel/getQueryTagOperatorValue',
        payload: {
          values: {},
        },
        callback: () => {},
      });
      if (tagId) {
        await dispatch({
          type: 'statisticsCreateLabel/queryTagAndRule',
          payload: {
            values: {
              tagId,
            },
          },
          callback: (data) => {
            const newData = JSON.parse(JSON.stringify(data));
            const updateStrategy = String(newData.updateStrategy);
            setValue('name', newData.name);
            setValue('pid', newData.pid);
            setValue('updateStrategy', updateStrategy);
            setValue('remark', newData.remark);
            setValue('status', String(newData.status));
            setValue('valueFieldId', newData.ruleBehaviorData.valueFieldId);
            setValue('valueMethod', newData.ruleBehaviorData.valueMethod);
            const newDataArr =
              newData.tagRule.length > 0
                ? [{ tagCollectionRule: newData.tagRule, id: createId() }]
                : [initDetailForm()];
            if (newDataArr.length > 0) {
              newDataArr.forEach((item) => {
                if (item.tagCollectionRule) {
                  let tagCollectionRuleIn = [];
                  let tagCollectionRuleOut = [];
                  item.tagCollectionRule.forEach((it) => {
                    it.tagRuleOutsideData.forEach((x) => {
                      x.withinItem.forEach((y) => {
                        y.valueFieldIds = initValueFieldIds(
                          y.valueFieldIds,
                          directoryList,
                        );
                      });
                    });
                    if (it.type === 1) {
                      tagCollectionRuleIn = it.tagRuleOutsideData.map((i) => {
                        return { ...i, id: createId() };
                      });
                    } else {
                      tagCollectionRuleOut = it.tagRuleOutsideData.map((i) => {
                        return { ...i, id: createId() };
                      });
                    }
                  });
                  item.tagCollectionRuleIn = tagCollectionRuleIn;
                  item.tagCollectionRuleOut = tagCollectionRuleOut;
                  delete item.tagCollectionRule;
                }
              });
            }
            const ruleBehaviorDataArr = [newData.ruleBehaviorData];
            ruleBehaviorDataArr.forEach((item) => {
              if (item.valueFieldIds) {
                item.valueFieldIds = initValueFieldIds(
                  item.valueFieldIds,
                  directoryList,
                );
              }
              if (
                item.operationValue &&
                item.operationValue.indexOf('startDate') > -1
              ) {
                item.operationValue = JSON.parse(item.operationValue);
              }
            });
            setTagRule(ruleBehaviorDataArr);
            setTagCollectionInfo(newDataArr);
          },
        });
      }
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tagId]);
  //点击新增一条集合，最外层的新增按钮
  // const handleAddCollectionlData = () => {
  //   tagCollectionInfo.push(initDetailForm());
  //   setTagCollectionInfo([...tagCollectionInfo]);
  // };

  //点击新增一条详细设置
  const handleAddRuleData = ({ id, type }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        if (type) {
          item.tagCollectionRuleIn.push({
            outsideSort: '',
            id: createId(),
            withinItem: [createObj()],
          });
        } else {
          item.tagCollectionRuleOut.push({
            outsideSort: '',
            id: createId(),
            withinItem: [createObj()],
          });
        }
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };
  //点击新增一条详细设置的删除
  const handleAddRuleDataDelete = ({ id, type, selfId }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        if (type) {
          const newData = item.tagCollectionRuleIn.filter(
            (it) => selfId !== it.id,
          );
          item.tagCollectionRuleIn = newData;
        } else {
          const newData = item.tagCollectionRuleOut.filter(
            (it) => selfId !== it.id,
          );
          item.tagCollectionRuleOut = newData;
        }
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };

  //点击新增一条详细规则设置， type===true是满足，
  const handleAddRuleDetailData = ({ id, pid, type }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === id) {
            it.withinItem.push(createObj());
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };

  //点击新增一条详细规则设置删除，type===true是满足， selfId最里面行id，wid框id，pid详细设定id,
  const handleAddRuleDetailDataDelete = ({ wid, selfId, pid, type }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === wid) {
            const newWithinItem = it.withinItem.filter((i) => i.id !== selfId);
            it.withinItem = newWithinItem;
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };

  const setFieldValue = (parameter) => {
    const { wid, selfId, pid, type, value, realName, id } = parameter;
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        item[realName] = value;
        return;
      }
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === wid) {
            it.withinItem.forEach((eIt) => {
              if (eIt.id === selfId) {
                eIt[realName] = value;
                return;
              }
            });
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo(tagCollectionInfo);
  };
  const setFieldValueData = (parameter) => {
    const { selfId, value, realName } = parameter;
    tagRule.forEach((item) => {
      if (item.id === selfId) {
        item[realName] = value;
      }
    });
    setTagRule(tagRule);
  };

  //删除最外层的卡片
  const handleDetailDelete = ({ id }) => {
    const newTagCollectionInfo = tagCollectionInfo.filter(
      (item) => item.id !== id,
    );
    if (typeof id === 'number') {
      deleteIds.push(id);
      setDeleteIds(deleteIds);
    }
    setTagCollectionInfo([...newTagCollectionInfo]);
  };
  //重置详细设置
  const handleRefreshDetail = ({ id }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        item.tagCollectionRuleIn = [];
        item.tagCollectionRuleOut = [];
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };
  const handleSubmitData = () => {
    // setOpenError(true);
    setSaveOpen({
      status: true,
      tips: '确认保存当前所创建的内容？',
      title: '保存',
    });
  };
  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
        >
          取消
        </Button>
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const onSaveLabelDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
    if (saveOpen.title === '保存') {
      submitRef.current.click();
    } else if (saveOpen.title === '退出') {
      history.goBack();
    } else {
      dispatch({
        type: 'statisticsCreateLabel/deleteLabel',
        payload: {
          values: {
            tagId,
          },
        },
        callback(res) {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '删除成功',
              title: '删除成功',
            });
            webStorage.set('DELETE_TAG', tagId);
            setTimeout(() => {
              history.goBack();
            }, 2000);
          }
        },
      });
    }
  };

  const onCloseDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
  };

  const watchTestParamsData = useMemo(() => {
    if (watchTestParams) {
      const id = watchTestParams[0]?.id;
      return ruleLabelDirectoryList.find((item) => item.id === id)?.children;
    }
    return [];
  }, [watchTestParams]);

  const conditionTypeCodeVip = useMemo(() => {
    if (watchTestParams) {
      const id = watchTestParams[0]?.id;
      return ruleLabelDirectoryList.find((item) => item.id === id)
        ?.conditionTypeCode;
    }
    return [];
  }, [watchTestParams]);

  const conditionTypeCode = useMemo(() => {
    return (
      watchTestParamsData?.find((item) => item.id === watchValueFieldId)
        ?.conditionTypeCode || ''
    );
  }, [watchValueFieldId, watchTestParamsData]);

  //详情
  useEffect(() => {
    setBeHavCondition(dicObj[conditionTypeCode]);
  }, [queryType, conditionTypeCode]);

  const handleDelete = () => {
    setSaveOpen({
      status: true,
      tips: `确认删除“${getValues('name')}”标签？删除后将无法复原。`,
      title: '删除',
    });
  };
  return (
    <CollectionLabelStyled>
      <Box
        data-log={JSON.stringify({
          oid: 'page_user_profile_label_management_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <Loading loading={loading}>
          <form onSubmit={handleSubmit(onSubmitSuccess, onSubmitError)}>
            <Box borderRadius="12px" bgcolor="background.paper" p={4}>
              <TitleML title="标签基本设置" fontSize="19px" p="0 0 32px 0" />
              <BasicML
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                setError={setError}
                clearErrors={clearErrors}
              />
            </Box>
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
            >
              <TitleML title="标签规则设置" fontSize="19px" p="0" />
              <Box
                sx={{
                  fontSize: 12,
                  color: '#212100',
                  marginBottom: '23px',
                  marginTop: '20px',
                }}
              >
                <span style={{ color: 'red' }}>*</span>
                <span style={{ color: '#555' }}>数据范围</span>
                <LabelRules
                  queryType={queryType}
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  errors={errors}
                  tagRule={tagRule} //非集合标签规则数据
                  setError={setError}
                  clearErrors={clearErrors}
                  type="4"
                  setFieldValueP={setFieldValueData}
                />
              </Box>
              <span style={{ color: '#555', fontSize: 12 }}>条件范围</span>
              <DetailML
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                tagCollectionInfo={tagCollectionInfo} //详细设置的数据
                setError={setError}
                clearErrors={clearErrors}
                handleAddRuleData={handleAddRuleData}
                handleAddRuleDataDelete={handleAddRuleDataDelete}
                handleAddRuleDetailData={handleAddRuleDetailData}
                handleAddRuleDetailDataDelete={handleAddRuleDetailDataDelete}
                handleDetailDelete={handleDetailDelete}
                handleRefreshDetail={handleRefreshDetail}
                setFieldValue={setFieldValue}
                ruleLabelDirectoryList={ruleLabelDirectoryList} //级联数据
              />
              <Box className="line" sx={{ gap: '0 48px', display: 'flex' }}>
                <Box sx={{ width: '280px' }}>
                  <Box>
                    <span style={{ color: 'red' }}>*</span>
                    <span style={{ color: '#555' }}>取值内容</span>
                  </Box>
                  <SelectFieldCom
                    label="取值内容"
                    initLabel=""
                    placeholder="请选择"
                    name="valueFieldId"
                    queryType={queryType}
                    setValue={setValue}
                    getValues={getValues}
                    control={control}
                    errors={errors}
                    setError={setError}
                    clearErrors={clearErrors}
                    nameMessage="取值内容是必选项"
                    typeList={watchTestParamsData || []}
                    showError={true}
                    fieldNames={{ label: 'fileName', value: 'id' }}
                    rules={{
                      required: true,
                    }}
                  />
                </Box>
                {conditionTypeCodeVip !== 'DIMENSION_TABLE' && (
                  <Box width="280px">
                    <Box>
                      <span style={{ color: 'red' }}>*</span>
                      <span style={{ color: '#555' }}>取值方式</span>
                    </Box>
                    <SelectFieldCom
                      label="取值方式"
                      initLabel=""
                      placeholder="请选择"
                      name="valueMethod"
                      queryType={queryType}
                      setValue={setValue}
                      control={control}
                      errors={errors}
                      getValues={getValues}
                      setError={setError}
                      clearErrors={clearErrors}
                      nameMessage="取值方式是必选项"
                      typeList={beHavCondition || []}
                      showError={true}
                      fieldNames={{ label: 'nameZh', value: 'dictCode' }}
                      rules={{
                        required: true,
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
              className="button-wrap"
            >
              {queryType !== 'detail' && (
                <LoadingButton
                  variant="contained"
                  onClick={handleSubmitData}
                  loading={isLoading}
                  loadingPosition="start"
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  sx={{ marginRight: '16px' }}
                >
                  保存
                </LoadingButton>
              )}
              {queryType === 'edit' && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_label_management_edit_delete',
                    events: ['_ev', '_ec'],
                    params: {
                      tagId,
                    },
                  })}
                  style={{
                    marginRight: '15px',
                    backgroundColor:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#CA2C21'
                        : '#F5F5F5',
                    color:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#fff'
                        : '#ccc',
                  }}
                  variant="contained"
                  className="cancel"
                  startIcon={
                    <DeleteIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={
                    userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1 &&
                    handleDelete
                  }
                >
                  删除
                </Button>
              )}
              <Button
                variant="contained"
                color="secondary"
                className="cancel"
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={() => handleClickOpen()}
              >
                退出
              </Button>
            </Box>
            <Button
              data-log={JSON.stringify({
                oid: 'btn_user_profile_label_management_edit_save',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              sx={{ display: 'none' }}
              type="submit"
              ref={submitRef}
            ></Button>
          </form>
        </Loading>
        <DialogDataML
          open={saveOpen.status}
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <span
                style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
              >
                {saveOpen.title}
              </span>
            </Box>
          }
          content={<Box sx={{ width: '336px' }}>{saveOpen.tips}</Box>}
          handleClose={onCloseDialog}
          button={initButton()}
        />
      </Box>
    </CollectionLabelStyled>
  );
};
